import { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import { USERS_API } from "../../constants/api";
import { useUsers } from "../../hooks/users/useUsers";
import { kTimestamp } from "../../constants/strings";
import { orderBy, query, where } from "firebase/firestore";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";
import { STATUS_STAFF } from "../../constants/webapp";

export const UserRegister = ({ status }) => {
  const { customerTableColumns, customerTableData } = useUsers();

  function getQuery(status) {
    if (status === STATUS_STAFF) return where("is_staff", "==", true);
    return orderBy(kTimestamp, "desc");
  }

  const baseQuery = query(USERS_API, getQuery(status), getDefaultLimit());

  const {
    fetchMore,
    paginatedList: users,
    getList: getUsers,
    loading,
  } = usePagination(baseQuery);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div>
      <CollapseTable
        loading={loading}
        columns={customerTableColumns}
        rows={customerTableData(users, status)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
